
import pointModel from "./point-model.vue"
import ignitionPoint from "./point-fire.vue"
import diffusionCircle from "./diffusion-circle.vue"
import lineRoam from "./line-roam.vue"
import RightAngleArrow from "./RightAngleArrow.vue"
import commonPlot from "./common-plot.vue"
import MilitaryPlot from "../../MilitaryPlot/index.vue"
import pointExplot from "./point-explot.vue"
import sceneBookmark from "./scene-bookmark.vue"
import myPlot from "./myPlot.vue"
export default {
    "myPlot": {name:"我的标绘",com:myPlot},
    "sceneBookmark": {name:"场景书签",com:sceneBookmark},
    "commonPlot": {name:"常用标绘",com:commonPlot},
    "militaryPlot": {name:"军事标绘",com:MilitaryPlot},
    "pointModel": {name:"模型标绘",com:pointModel},
    "pointExplot":{name:"爆炸点",com:pointExplot},
    "ignitionPoint":{name:"着火点",com:ignitionPoint},
    "diffusionCircle":{name:"扩散圆",com:diffusionCircle},
    "lineRoam":{name:"线路漫游",com:lineRoam},
    "RightAngleArrow":{name:"直角箭头",com:RightAngleArrow},
}